import { ChartType, MapChartLocation, MapChartType, } from '../../../../../../types/savedCharts';
export const getMapChartConfig = ({ queryTool, metricQuery, }) => {
    const { chartConfig } = queryTool;
    const [firstDimension, secondDimension] = queryTool.queryConfig.dimensions;
    return {
        type: ChartType.MAP,
        config: {
            mapType: chartConfig?.mapType ?? MapChartLocation.WORLD,
            locationType: chartConfig?.mapLocationType ?? MapChartType.SCATTER,
            latitudeFieldId: chartConfig?.mapLatitudeFieldId ?? firstDimension,
            longitudeFieldId: chartConfig?.mapLongitudeFieldId ?? secondDimension,
            locationFieldId: chartConfig?.mapLocationFieldId ?? firstDimension,
            valueFieldId: chartConfig?.mapValueFieldId ??
                chartConfig?.yAxisMetrics?.[0] ??
                metricQuery.metrics[0],
        },
    };
};
//# sourceMappingURL=map.js.map